// SPDX-License-Identifier: Elastic-2.0
/**
 * parsePrefill — parse the `?prefill=...` query param for NewRoutineStub (T-026).
 *
 * Lives in its own module because `react-refresh/only-export-components`
 * forbids non-component exports from a `.tsx` file (Fast Refresh
 * compatibility). Keeping the parser separate also makes the helper
 * trivially unit-testable without rendering the stub.
 *
 * v0.1 vocabulary: only `prefill=device:{id}` is recognised. Everything
 * else returns `null` so the stub falls through to the redirect branch.
 * Future kinds (`room:{id}`, `scene:{id}`) can be added by extending
 * the switch — the consumer just needs to handle the new shape.
 */
export type PrefillTarget = { kind: "device"; id: string };

export function parsePrefill(raw: string | null): PrefillTarget | null {
  if (!raw) return null;
  const idx = raw.indexOf(":");
  if (idx <= 0 || idx === raw.length - 1) return null;
  const kind = raw.slice(0, idx);
  const id = raw.slice(idx + 1);
  if (kind === "device" && id.length > 0) {
    return { kind: "device", id };
  }
  return null;
}
